import styled from 'styled-components';

const Spacer = styled.div`
  @media screen {
    z-index: 2;
    position: sticky;
    top: 0;
  }
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    background: #eee;
    height: ${({ theme }) => theme.spacing.xl};
  }
`;

const FlexBox = styled.div`
  @media screen {
    background: white;

    & > div {
      justify-items: center;
      align-items: center;

      &:first-child {
        box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.05), 0 1px 3px rgba(0, 0, 0, 0.1),
          0 4px 11px rgba(0, 0, 0, 0.2);
        position: sticky;
        top: 0;
        @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
          top: 3rem;
        }
        z-index: 3;

        & > div:first-child {
          padding: 0.5rem;
          background: white;
          padding-bottom: 1rem;
        }
      }
    }

    padding-top: 0;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin: 0 auto;
    margin-top: 3rem;
    max-width: 58rem;

    box-shadow: 0 -1px 10px rgba(0, 0, 0, 0.05), 0 1px 4px rgba(0, 0, 0, 0.1),
      0 10px 30px #f3ece8;
  }

  @media print {
    #menu,
    #calendar .calendar .icon,
    #calendar .calendar > div {
      display: none;
    }

    #calendarHeader {
      all: initial;
      * {
        all: unset;
      }

      display: block !important;

      h4 div {
        padding: 5px 10px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        border-bottom: double #000;
      }
      h4 .monthTitle {
        font-size: 2em;
      }

      h4 .badge {
        font-size: 1.5em;
      }
    }
  }
`;

const Pane = styled.div`
  @media screen {
    margin-top: 0;
  }

  @media print {
    all: initial;
    * {
      all: unset;
    }

    padding: 5px;

    .createButton,
    .noEntries,
    .empty {
      display: none !important;
    }
    .day {
      display: block;
      padding: 3px 10px;
      margin-bottom: 40px;
      page-break-inside: avoid;
    }
    .day h5 {
      text-decoration: none;
      font-weight: bold;
      display: grid !important;
      grid-template-columns: 80% 20%;
      text-align: left;
      padding: 0;
      border-bottom: 1px solid #000;
      margin-bottom: 0px;
      line-height: 0.8em;
      font-size: 1.2em;
      white-space: nowrap;
    }

    .day .badge {
      margin-left: 0.25em;
      display: flex;
      justify-content: flex-end;
    }
    .timeSheetRow {
      width: 100%;
      display: grid !important;
      grid-template-columns: 20% 60% 20%;
      font-weight: normal;
      margin-top: 10px;
      justify-content: space-between;
      padding-left: 5px;
      font-size: 1.1em;
      & a {
        text-decoration: none;
        font-size: 1.1em;
      }
    }
    .text-muted {
      color: black !important;
    }
    .timeSheetRow div:nth-of-type(2) {
      order: 3;
      text-align: right;
      font-weight: normal;
      color: black;
      padding-right: 0;
    }
    .timeSheetRow div:nth-of-type(3) {
      order: 2;
    }
  }
`;

export default { FlexBox, Spacer, Pane };
